"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));

var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  paper: {
    backgroundColor: props => {
      return props.backgroundColor;
    },
    color: "black",
    maxWidth: "320px",
    zIndex: 2
  },
  arrow: {
    position: "absolute",
    zIndex: 1,
    fontSize: "7px",
    width: "3em",
    height: "3em",
    "[x-placement*=top] &": {
      bottom: 0,
      width: 0,
      height: 0,
      borderLeft: "1em solid transparent",
      borderRight: "1em solid transparent",
      borderTop: "1em solid",
      borderTopColor: props => {
        return props.arrowColor;
      },
      marginBottom: "-1em"
    },
    "[x-placement*=bottom] &": {
      width: 0,
      height: 0,
      borderLeft: "1em solid transparent",
      borderRight: "1em solid transparent",
      borderBottom: "1em solid",
      borderBottomColor: props => {
        return props.arrowColor;
      },
      marginTop: "-1em"
    },
    "[x-placement*=right] &": {
      left: 0,
      width: 0,
      height: 0,
      borderTop: "1em solid transparent",
      borderBottom: "1em solid transparent",
      borderRight: "1em solid",
      borderRightColor: props => {
        return props.arrowColor;
      },
      marginLeft: "-1em"
    },
    "[x-placement*=left] &": {
      right: 0,
      width: 0,
      height: 0,
      borderTop: "1em solid transparent",
      borderBottom: "1em solid transparent",
      borderLeft: "1em solid",
      marginRight: "-0.9em"
    }
  }
}));

const UserDropdown = ({
  children,
  expanded,
  onCollapse,
  anchorEl,
  placement = "bottom-end"
}) => {
  const classes = useStyles({
    backgroundColor: "white",
    arrowColor: "white"
  });
  return _react.default.createElement(_Popper.default, {
    open: expanded,
    style: {
      zIndex: 2000
    },
    role: undefined,
    transition: true,
    anchorEl: anchorEl,
    placement: placement,
    modifiers: {
      arrow: {
        enabled: true,
        element: "[data-popper-arrow]"
      }
    }
  }, _react.default.createElement("div", {
    className: classes.arrow,
    "data-popper-arrow": true
  }), _react.default.createElement(_ClickAwayListener.default, {
    onClickAway: onCollapse
  }, _react.default.createElement(_Paper.default, {
    className: classes.paper,
    elevation: 24,
    square: true
  }, children)));
};

var _default = UserDropdown;
exports.default = _default;
module.exports = exports.default;